import { getEmployees } from '@/Webservice/Employee';
function createState() {
    return {
        employees: [],
        isLoading: false
    };
}
export const Employees = {
    namespaced: true,
    state: createState(),
    mutations: {
        setEmployees(state, payload) {
            state.employees = payload;
        },
        setIsLoading(state, payload) {
            state.isLoading = payload;
        },
        resetState(state) {
            Object.assign(state, createState());
        }
    },
    actions: {
        async getEmployees(store) {
            setLoading(store, true);
            try {
                const data = await getEmployees();
                store.commit("setEmployees", data);
            }
            finally {
                setLoading(store, false);
            }
        }
    }
};
function setLoading(store, isLoading) {
    store.commit("setIsLoading", isLoading);
}
